export enum HeaderTable{
    titleForProductCategoryTable = 'Product Category',  
  }
  
  export enum HeaderColumns {
    productCategoryName = 'Naziv',  
  }
  
  export enum ModalForAddOrUpdateProductCategory {
    titleForAddProductCategory = 'Dodavanje nove kategorije',
    titleForUpdateProductCategory = 'Izmena naziva kategorije',
    productCategoryNameEmpty = 'Potrebno je uneti naziv kategorije.',
    productCategoryNamePlaceholder = 'Naziv',
    saveSuccessMessage = 'Nova kategorija je uspešno sačuvana.',
    updateSuccessMessage = 'Naziv kategorije je uspešno izmenjen.',
    deleteSuccessMessage = 'Izabrana kategorija je uspešno obrisana.',
  }